import React from 'react';

function LoadingSpinner({ fullScreen = false, message = '로딩 중...' }) {
  const containerStyle = fullScreen
    ? {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(245, 230, 211, 0.95)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      }
    : {
        textAlign: 'center',
        padding: '40px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      };

  return (
    <div style={containerStyle}>
      <div
        style={{
          width: '48px',
          height: '48px',
          border: '4px solid #FAF3E8',
          borderTop: '4px solid #E8A87C',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}
      />
      <p
        style={{
          color: '#8B7355',
          marginTop: '16px',
          fontSize: '14px'
        }}
      >
        {message}
      </p>
    </div>
  );
}

export default LoadingSpinner;
